import React, { useEffect } from "react";
import HeroMain from "./HeroMain";
import GamesMain from "./GamesMain";
import ContactMain from "./ContactMain";
import FooterMain from "./FooterMain";
import MessageBanner from "./MessageBanner";
import ScrollDotsMain from "./ScrollDotsMain";
import ScrollButtonMain from "./ScrollButtonMain";

export default function MainPage() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, 0);

    let prevIsDesktop = window.innerWidth >= 1024;

    const handleResize = () => {
      const isDesktop = window.innerWidth >= 1024;

      if (!prevIsDesktop && isDesktop) {
        window.location.reload();
      }

      prevIsDesktop = isDesktop;
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <ScrollDotsMain />
      <HeroMain />

       <main className="bg-gradient-to-b from-black via-[#0a0a0a] to-[#111]">
      <GamesMain />

        <section
          id="contact"
          className="lg:h-screen lg:snap-start lg:flex lg:flex-col"
        >
          <div className="flex items-center justify-center lg:flex-1">
            <ContactMain />
          </div>
          <FooterMain />
        </section>
      </main>

      <MessageBanner />
      <ScrollButtonMain />
    </>
  );
}
